import { useContext } from "react"
import EditPropertyContext from "./EditPropertyContext"
import { PropertyListItem } from "./propertyModel"
import { faTags } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

type Props = {
  property: PropertyListItem
}

const PropertiesSidebarItem = ({property}: Props) => {
  const { selectedPropertyId, selectProperty, showDeletedView } = useContext(EditPropertyContext)

  const divClasses = ['properties-sidebar-list-item']
  if (selectedPropertyId === property.id) {
    divClasses.push('property-selected')
  }
  if (showDeletedView) {
    divClasses.push('property-deleted')
  }

  return <div 
    className={divClasses.join(' ')}
    onClick={() => selectProperty(property.id, false)}
  >
    {!!property.nickname && <>{property.nickname}<br/></>}
    {property.address}
    <br />
    {property.cityStateZip}
    <br />
    {!!property.tags && <small><FontAwesomeIcon icon={faTags} /> {property.tags}</small>}
  </div>
}

export default PropertiesSidebarItem